if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: true,
        currentAvailableOptions: [],
        options: [],
        init() {
          if (!is_combined) {
            this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
          }

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            if (!is_combined) {
              this.currentAvailableOptions = e.detail.currentAvailableOptions,
              this.options = e.detail.options;
            }

            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
            this.renderVariantTitle(e.detail.html);
            this.renderVariantId(e.detail.html);
            this.renderButton(e.detail.html);
          });
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariantTitle(html) {
          const destination = document.getElementById('variant-title-sticky-' + sectionId);
          const source = html.getElementById('variant-title-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariantId(html) {
          const destination = document.getElementById('update-variant-sticky-' + sectionId);
          const source = html.getElementById('update-variant-sticky-' + sectionId);

          if (source && destination) {
            destination.value = source.value;
            destination.dispatchEvent(new Event('change', { bubbles: true }));
          }
        },
        renderButton(html) {
          const destination = document.querySelector(`#product-form-sticky-${sectionId} .add_to_cart_button`);
          const source = html.querySelector(`#product-form-sticky-${sectionId} .add_to_cart_button`);

          if (!destination || !source) return;

          destination.innerHTML = source.innerHTML;
          destination.dataset.available = source.dataset.available;

          if (source.disabled) {
            destination.setAttribute('disabled', 'disabled');
          } else {
            destination.removeAttribute('disabled');
          }
        }
      }))
    })
  })
}
